var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSBeat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20699_98251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "#F86424",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21735 2.33338C5.44074 2.33482 5.63312 2.49216 5.67993 2.71172L7.06169 9.19301L8.32721 4.6537C8.38117 4.46015 8.5497 4.3211 8.74908 4.30563C8.94847 4.29016 9.13624 4.40156 9.21911 4.58449L9.98499 6.70092H12.3572C12.6202 6.70092 12.8334 6.91521 12.8334 7.17956C12.8334 7.4439 12.6202 7.65819 12.3572 7.65819H9.67859C9.49197 7.65819 9.32256 7.54862 9.24522 7.37791L8.89255 6.59944L7.45855 11.3172C7.39945 11.5292 7.20414 11.6733 6.98523 11.6665C6.76633 11.6596 6.58029 11.5036 6.5344 11.2884L5.20022 5.03024L4.78576 7.28581C4.73642 7.50364 4.54371 7.65819 4.32145 7.65819H1.64288C1.37988 7.65819 1.16669 7.4439 1.16669 7.17956C1.16669 6.91521 1.37988 6.70092 1.64288 6.70092H3.94149L4.75 2.70575C4.79959 2.48681 4.99395 2.33195 5.21735 2.33338Z",
    fill: "#E84600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20699_98251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSBeat);
export default __webpack_public_path__ + "static/media/icon-s-beat.85ac68912cd22669bacccdf3dcae4c3f.svg";
export { ForwardRef as ReactComponent };